import http from 'plugins/axios';

export default {
  list(data) {
    return http.get({
      url: '/la/admin/api/request/log/list',
      data
    });
  }
};
